import React, { useState } from 'react';
import './navbar.css';
import birdLogo from '../assets/Jivebirdimg.png';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ExampleIcon from '../assets/examples.png';
import logojb from '../assets/TextLogo.png';

export default function Navbar({sender,songNameVisible,songName}) {
  const [show, setShow] = useState(false);

  const closesidebar = () => {
    setShow(false);
  };

  const renderCurrentTab = () => {
    return <div className="current-tab-title">{sender? `From ${sender}` : ''}<br/>{songName? `${songName}` : ''}</div>;
  };

  return (
    <>
      <nav
        className="navbar-new navbar-expand-lg navbar-light-new bg-light-new sticky "
        role="navigation"
      >


        <div
          className="collapse-new navbar-collapse myNavbar"
          id="navbarTogglerDemo01"
        >
          <div className="center-title-container">
            
              <img
                className="logo-image"
                style={{ width: '180px' }}
                src={birdLogo}
                alt='bird-logo'
              />
            {' '}
            <div
              className="tab-div"
              style={{ width: '180px', textAlign: 'center' }}
            >
              {renderCurrentTab()}
            </div>
          </div>

          <div className="form-inline ml-auto">
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
             

              <div className="menu-circle-new" onClick={() => setShow(true)}>
                <li className="navbar nav-menu nav-item d-flex justify-content-center align-items-center">
                  <Button variant="link" className="p-0 d-lg-block d-md-none">
                    <i
                      className="fas fa-ellipsis-v fa-2x menu-bars"
                      style={{ color: 'white' }}
                    ></i>
                  </Button>
                </li>
              </div>
            </ul>
            <Modal
              show={show}
              onHide={() => setShow(false)}
              contentClassName="custom-modal-style"
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
            >
              <Modal.Header className="ModalHead">
                <Modal.Title id="example-custom-modal-styling-title">
                  <h2 style={{marginTop: '1rem'}}>
                    <i
                      className="fas fa-chevron-left sidebarhead"
                      onClick={closesidebar}
                    ></i>
                    <img alt='logo-jb' style={{ width: '164px' }} src={logojb} />
                  </h2>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="CustomModalBody">

                {/* <a role="button">
                  <p onClick={() => handleCurrentScreen(13)}>
                    <i
                      className="fas fa-question-circle sidebaricon"
                      style={{ color: '#d6b7d8', fontSize: '25px' }}
                    ></i>
                    FAQ's
                  </p>
                </a> */}
                {/* <a role="button">
                  <p onClick={() => handleCurrentScreen(12)}>
                    <i
                      className="fas fa-info-circle sidebaricon"
                      style={{ color: '#d6b7d8', fontSize: '25px' }}
                    ></i>
                    About
                  </p>
                </a> */}
                <a role="button" href='https://www.jivebird.com/what-is-a-jivebird/' target='_blank'  rel="noopener noreferrer">
                  <p >
                    <i
                      className="fas fa-info-circle sidebaricon"
                      style={{ color: '#d6b7d8', fontSize: '25px' }}
                    ></i>
                    What is a JB? 
                  </p>
                </a>

                <a role="button" href='https://www.jivebird.com' target='_blank'  rel="noopener noreferrer">
                  <p>
                    <i>
                      {' '}
                      <img alt='example-icon' className="mr-4" src={ExampleIcon} />
                    </i>
                    Go to JiveBird
                  </p>
                </a>

                {/* <a role="button">
                  <p onClick={() => handleCurrentScreen(10)}>
                    <i
                      className="fas fa-comment-alt sidebaricon"
                      style={{ color: '#d6b7d8', fontSize: '25px' }}
                    ></i>
                    Contact
                  </p>
                </a> */}
                <a
                  href="https://www.jivebird.com/terms-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p>
                    <i
                      className="fas fa-info-circle sidebaricon"
                      style={{ color: '#d6b7d8', fontSize: '25px' }}
                    ></i>
                    Terms & Conditions
                  </p>
                </a>
                
              </Modal.Body>
            </Modal>
          </div>
        </div>
        <Button
          variant="link"
          onClick={() => setShow(true)}
          className="p-0 d-lg-none"
        >
          <i
            className="fas fa-ellipsis-v fa-2x menu-bars"
            style={{ color: 'white' }}
          ></i>
        </Button>
      </nav>
    </>
  );
}
